module.exports = __webpack_public_path__ + "img/9.f6373ad4.jpg";